import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import AppProvider from "./context/AppProvider";
import { ViewportProvider, useViewport } from "../../components/ReactContext_Viewport";
import { Grommet, Box } from "grommet";
import cpawTheme from "./theme";
import Layout from "./Layout";
import ToolBoxSplash from "./components/ToolboxSplash";
import ToolBoxContent from "./components/ToolBoxContent";

// import HeMainTheme from "../../grommet-themes/he-main";
// import { deepMerge } from "grommet/utils";

// import StartScreen from "./screens/StartScreen";
// import MainScreen from "./screens/MainScreen";
// import colors from "./assets/colors";
// import FeedbackModal from "./components/FeedbackModal";

import GoogleAnalytics from "../../components/GoogleAnalyticsWithRouter";

// const epsExplore = deepMerge(HeMainTheme, {
//     global: {
//         colors: {
//             brand: colors.brand,
//             brandLight: colors.brandLight,
//             accent: colors.accent,
//             error: colors.error,
//             warning: colors.warning,
//         },
//         font: {
//             family: "museo-sans",
//             size: "18px",
//             height: "20px",
//             color: "#222",
//         },
//     },
// });

const App = () => {
    document.title = "Firetopia Land Use Toolbox | CPAW";
    return (
        <Router basename={"/apps/firetopia"}>
            <Routed />
        </Router>
    );
};

//Split out so Storybook can use a different type of router
const Routed = ({ storybookState }) => {
    return (
        <AppProvider storybookState={storybookState}>
            <ViewportProvider>
                <GrommetContainer />
            </ViewportProvider>
        </AppProvider>
    );
};

const GrommetContainer = () => {
    const { appWidth } = useViewport();
    return (
        <Grommet className="app" full={appWidth < 1000 ? false : true} theme={cpawTheme}>
            <GoogleAnalytics siteID="UA-80888816-1" productionHostname="cpaw.headwaterseconomics.org" />
            <Box fill>
                <Switch>
                    
                    <Route
                        exact
                        path="/"
                        // component={ToolBoxSplash}
                        component={() => {
                            return <Layout mainContent={<ToolBoxSplash />} />;
                        }}
                    />
                    <Route
                        path="/:postSlug"
                        component={() => {
                            return <Layout mainContent={<ToolBoxContent />} />;
                        }}
                    />
                </Switch>
            </Box>
        </Grommet>
    );
};
export { Routed };

export default App;

// import React, { useRef, useEffect, useState } from "react";
// import { BrowserRouter } from "react-router-dom";
// import "./App.scss";
// import {
//     Grommet,
//     Layer,
//     Box,
//     Button,
//     Paragraph,
//     Text,
//     Image,
//     Grid,
//     Heading,
//     Anchor,
//     Tip,
//     Header,
//     DropButton,
// } from "grommet";
// import { useViewport, ViewportProvider } from "../../components/ReactContext_Viewport";
// // import { ToolBoxContent,ToolBoxNav,ToolBoxSplash } from "./ToolBox";

// import { Link, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
// import cpawTheme from "./theme";
// import ToolBoxInfo from "./ToolBoxInfo";
// import useFetch from "./useFetch";

// import blurredBG from "./assets/blurredbg.jpg";
// import SplashHome from "./assets/SplashHome.jpg";
// import InteractiveCanvas from "./assets/InteractiveCanvas.jpg";
// import ComPlanThumb from "./assets/CommunityPlans.jpg";
// import LandDevThumb from "./assets/LandDev.jpg";
// import BuildCodeThumb from "./assets/BuildCodes.jpg";
// import FuelsReductionThumb from "./assets/FuelsReduction.jpg";
// import FundEngageThumb from "./assets/FundingEngage.jpg";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faArrowAltToLeft,
//     faBars,
//     faExternalLink,
//     faHome,
//     faPlayCircle,
//     faUndo,
// } from "@fortawesome/pro-light-svg-icons";

// import ModalContent from "./components/ModalContent";
// import Sidebar from "./components/Sidebar";

// function App() {
//     const [isInteractiveVisible, set_isInteractiveVisible] = useState(false);
//     document.title = "Firetopia Land Use Toolbox | CPAW";

//     useEffect(() => {
//         setTimeout(set_isInteractiveVisible(true), 4000);
//     }, []);
//     const { screenSize, appWidth, appHeight } = useViewport();
//     const [open, setOpen] = useState();
//     const [selectedPostMeta, setSelectedPostMeta] = useState(null); // will be set to an object with slug and source elements
//     const [active, setActive] = useState(null);
//     const [selectedCat, setSelectedCat] = useState(null);
//     const [catOverview, setCatOverview] = useState(null);
//     const [ratio, setRatio] = useState(appWidth / appHeight);

//     const onOpen = () => {
//         setOpen(true);
//     };
//     const onClose = () => {
//         setOpen(false);
//     };

//     useEffect(() => {
//         setCatOverview(<SplashCat />);
//     }, []);

//     useEffect(() => {
//         function handleResize() {
//             setRatio(appWidth / appHeight);
//         }
//         window.addEventListener("resize", handleResize);
//         handleResize();
//         return () => window.removeEventListener("resize", handleResize);
//     });

//     const ToolBoxContent = () => {
//         let { slug } = useParams();
//         const baseURL =
//             ["127.0.0.1", "localhost"].indexOf(document.location.hostname) > -1
//                 ? "https://hecpawstage.wpengine.com"
//                 : "";
//         // const posts = useFetch(baseURL + "/wp-json/wp/v2/toolbox?slug=" + selectedPostMeta.slug);
//         const posts = useFetch(baseURL + "/wp-json/wp/v2/toolbox?slug=" + slug);

//         if (!selectedPostMeta || !posts) return null;

//         const post = posts[0];
//         const source = selectedPostMeta.source;

//         const catID = post["toolbox_category"];

//         // Trying to fetch the name of the category but I get an error about rendering more hooks than previous render.
//         // const categories = useFetch(baseURL + "/wp-json/wp/v2/toolbox_category?id=" + catID[0]);
//         // const category = categories[0];

//         return appWidth > "1200" ? (
//             <Box
//                 fill
//                 flex
//                 justify="between"
//                 pad={{
//                     top: screenSize === "tablet" ? "medium" : "large",
//                     left: screenSize === "tablet" ? "large" : "xlarge",
//                 }}
//                 background={{ color: "light-1", opacity: ".8" }}
//                 animation={"fadeIn"}
//             >
//                 <Grid
//                     areas={[
//                         { name: "header", start: [0, 0], end: [2, 0] },
//                         { name: "main", start: [0, 1], end: [1, 1] },
//                         { name: "sidebar", start: [2, 1], end: [2, 1] },
//                     ]}
//                     columns={["1fr", "1fr", "1fr"]}
//                     rows={["auto", "1fr", "auto"]}
//                     fill
//                 >
//                     {post && (
//                         <>
//                             <Box
//                                 gridArea="header"
//                                 pad={{ top: "small" }}
//                                 border={{ side: "bottom", color: selectedPostMeta.color, size: "xsmall" }}
//                             >
//                                 <Box direction="row" justify="start" pad={{ right: "medium" }} gap="small">
//                                     <Box
//                                         alignSelf="center"
//                                         flex={"shrink"}
//                                         height={{ max: "xsmall" }}
//                                         width={{ max: "xsmall" }}
//                                         round={"100%"}
//                                         overflow={"hidden"}
//                                         border={{ color: selectedPostMeta.color, size: "medium" }}
//                                         margin={{ bottom: "xsmall" }}
//                                     >
//                                         <Image height={"100%"} src={source.image} />
//                                     </Box>
//                                     <Box>
//                                         <Text color={selectedPostMeta.color} size="small">
//                                             {source.category}
//                                             {/* {console.log(category.name)} */}
//                                         </Text>
//                                         <Heading level="2" margin={"none"} size="xlarge">
//                                             {post.title.rendered}
//                                         </Heading>
//                                     </Box>
//                                 </Box>
//                             </Box>
//                             <Box
//                                 gridArea="main"
//                                 pad={{ vertical: "medium", right: "medium" }}
//                                 overflow={{ vertical: "scroll" }}
//                                 height={{ min: "fit-content" }}
//                             >
//                                 <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
//                             </Box>
//                             <Box
//                                 gridArea="sidebar"
//                                 background={{ color: selectedPostMeta.color, opacity: "weak" }}
//                                 pad={{
//                                     vertical: "medium",
//                                     left: "medium",
//                                     right: screenSize === "desktop" ? "xlarge" : "medium",
//                                 }}
//                             >
//                                 <Sidebar post={post} selectedPostMeta={selectedPostMeta} />
//                             </Box>
//                         </>
//                     )}
//                 </Grid>
//             </Box>
//         ) : (
//             post && (
//                 <Box height={{ min: "fit-content" }} overflow={{ vertical: appWidth < "1200" ? "scroll" : "auto" }}>
//                     <Box
//                         pad={{ top: "xsmall", horizontal: "large" }}
//                         border={{ side: "bottom", color: selectedPostMeta.color, size: "xsmall" }}
//                         background={{ color: selectedPostMeta.color, opacity: "weak" }}
//                         height={{ min: "fit-content" }}
//                     >
//                         <Text color={selectedPostMeta.color} size="small">
//                             {source.category}
//                         </Text>
//                         <Heading level="2" margin={"none"} size="xlarge">
//                             {post.title.rendered}
//                         </Heading>
//                     </Box>

//                     <Box pad={{ vertical: "small", horizontal: "large" }} height={{ min: "fit-content" }}>
//                         <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
//                     </Box>

//                     <Box
//                         background={{ color: selectedPostMeta.color, opacity: "weak" }}
//                         pad={{ vertical: "medium", horizontal: "large" }}
//                         height={{ min: "fit-content" }}
//                     >
//                         <Heading level="3" margin={{ bottom: "xsmall" }}>
//                             Resources
//                         </Heading>
//                         <Box gap="xsmall" height={{ min: "fit-content" }}>
//                             {post.acf.resources.map((item, i) => (
//                                 <Box key={"resourceListItem-" + i} height={{ min: "fit-content" }}>
//                                     <Anchor
//                                         target="_blank"
//                                         icon={<FontAwesomeIcon icon={faExternalLink} />}
//                                         label={
//                                             <Box>
//                                                 <Box>
//                                                     <Text weight={"bold"}>{item.resource_label}</Text>
//                                                 </Box>
//                                                 <Box>
//                                                     <Text size="xsmall" weight={"normal"}>
//                                                         {item.resource_provider}
//                                                     </Text>
//                                                 </Box>
//                                             </Box>
//                                         }
//                                         href={item.resource_url}
//                                         title={item.resource_label}
//                                     />
//                                 </Box>
//                             ))}
//                         </Box>
//                     </Box>
//                 </Box>
//             )
//         );
//     };

//     const SplashCat = () => {
//         return (
//             <Box
//                 margin={{ horizontal: "large" }}
//                 animation={{ type: screenSize != "mobile" ? "fadeIn" : null }}
//                 height={{ min: "fit-content" }}
//                 gap="large"
//                 style={{ zIndex: "2" }}
//             >
//                 <Box gap="large" justify="between">
//                     <Box
//                         background={{ color: "white", opacity: ".9" }}
//                         pad="medium"
//                         round="xxsmall"
//                         elevation="small"
//                         width={"medium"}
//                     >
//                         <Paragraph size={screenSize === "desktop" ? "large" : "medium"} fill margin={"none"}>
//                             Click on the circles or use the navigation to learn more about land use planning.
//                         </Paragraph>
//                     </Box>
//                 </Box>
//             </Box>
//         );
//     };

//     const CatDescriptionButton = (props) => {
//         const {
//             color = "brand",
//             cat = "",
//             icon = "",
//             top = "unset",
//             right = "unset",
//             bottom = "unset",
//             left = "unset",
//             description = "",
//         } = props;
//         return (
//             <Tip
//                 content={
//                     <Box direction="column">
//                         <Text textAlign="center">Discover more about</Text>
//                         <Text color={color} weight={"bold"} textAlign="center">
//                             {cat}
//                         </Text>
//                     </Box>
//                 }
//                 dropProps={{ align: { bottom: "top" } }}
//             >
//                 <Box
//                     round="100%"
//                     height={"auto"}
//                     width={"12%"}
//                     overflow="hidden"
//                     border={{ color: color, size: ratio * 8 + "px" }}
//                     className={"shadow"}
//                     style={{
//                         aspectRatio: "1 / 1",
//                         zIndex: "1",
//                         position: "absolute",
//                         top: top + "%",
//                         right: right + "%",
//                         bottom: bottom + "%",
//                         left: left + "%",
//                     }}
//                     onClick={() => {
//                         setCatOverview(
//                             <CatDescription
//                                 header={<ToolListIcon input={ToolBoxInfo} color={color} icon={icon} cat={cat} />}
//                             >
//                                 {description}
//                                 <ToolList input={ToolBoxInfo} cat={cat} color={color} />
//                             </CatDescription>
//                         );
//                         setSelectedCat(cat);
//                     }}
//                 ></Box>
//             </Tip>
//         );
//     };

//     const CatDescription = (props) => {
//         const { color = "white", header = "" } = props;
//         return (
//             <Box
//                 width={screenSize != "mobile" ? { min: "medium", width: "fit-content", max: "large" } : null}
//                 margin="medium"
//                 height={{ min: "fit-content" }}
//             >
//                 <Box>{header}</Box>
//                 <Box
//                     background={{ color: color, opacity: "strong" }}
//                     margin={{ top: "-1em", left: "medium" }}
//                     pad={{ horizontal: "medium", top: screenSize != "mobile" ? "medium" : "large", bottom: "medium" }}
//                     round="xxsmall"
//                     elevation="small"
//                     animation={{ type: screenSize != "mobile" ? "fadeIn" : null }}
//                     style={{ zIndex: "2" }}
//                 >
//                     {props.children}
//                 </Box>
//             </Box>
//         );
//     };

//     const ToolBoxSplash = () => {
//         return (
//             <Box
//                 fill
//                 // background={{image: "url("+SplashHome+")",opacity: "weak"}}
//                 background={{
//                     image: "url(" + InteractiveCanvas + ")",
//                     position: "bottom right",
//                     size: ratio > "1.3" ? "cover" : "contain",
//                     color: "#BCE2F8",
//                 }}
//                 overflow={{ vertical: "auto" }}
//                 height={{ min: "fit-content", max: "100%", height: "100%" }}
//                 style={{ position: "relative" }}
//                 flex="grow"
//             >
//                 <Box
//                     direction={appWidth < "1024" ? "column" : "row"}
//                     justify="between"
//                     gap="large"
//                     height={{ min: "fit-content" }}
//                     pad={{ top: "medium", bottom: "large", horizontal: "large" }}
//                     background={"linear-gradient(0deg, rgba(255,255,255,.3), rgba(255,255,255,1))"}
//                 >
//                     <Heading level={"2"} size={appWidth > "1300" ? "xlarge" : "large"} margin={{ bottom: "none" }}>
//                         Land use planning can help your community survive a wildfire
//                     </Heading>
//                     {appWidth < "1024" ? (
//                         <Button
//                             primary
//                             color={"brand"}
//                             icon={<FontAwesomeIcon icon={faPlayCircle} />}
//                             label={"Show Interactive"}
//                             size={"medium"}
//                             fill={false}
//                             onClick={() => {
//                                 set_isInteractiveVisible(true);
//                             }}
//                         />
//                     ) : (
//                         <Box
//                             width={{ min: "fit-content", max: "300px" }}
//                             height={{ min: "fit-content" }}
//                             onClick={() => {
//                                 set_isInteractiveVisible(true);
//                             }}
//                             style={{ zIndex: "2" }}
//                         >
//                             <Box
//                                 pad="small"
//                                 background={{ color: "dark-2", image: "url(" + SplashHome + ")" }}
//                                 width={"100%"}
//                                 height={"auto"}
//                                 round="xxsmall"
//                                 justify="around"
//                                 elevation="medium"
//                                 border={{ size: "medium", color: "brand" }}
//                                 className="shadow-inset"
//                                 style={{ aspectRatio: "16 / 9", zIndex: "1" }}
//                             >
//                                 <Box
//                                     round="xxsmall"
//                                     fill={false}
//                                     width={{ min: "fit-content" }}
//                                     background={"brand"}
//                                     direction="row"
//                                     justify="center"
//                                     align="center"
//                                     gap="small"
//                                     pad={{ vertical: "xsmall", horizontal: "small" }}
//                                 >
//                                     <FontAwesomeIcon icon={faPlayCircle} size={"lg"} />
//                                     <Text size="medium">Show Interactive</Text>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     )}
//                 </Box>
//                 <Box fill flex={screenSize != "mobile" ? "shrink" : "grow"} style={{ position: "relative" }}>
//                     {screenSize != "mobile" ? (
//                         <>
//                             <Box
//                                 fill
//                                 onClick={() => {
//                                     setCatOverview(<SplashCat />);
//                                     setSelectedCat(null);
//                                 }}
//                                 style={{ position: "absolute", bottom: "0", left: "0", zIndex: "1" }}
//                             />
//                             <Box
//                                 style={{ position: "relative" }}
//                                 background={"linear-gradient(0deg, rgba(255,255,255,0), rgba(255,255,255,.3))"}
//                             >
//                                 {catOverview}
//                             </Box>
//                             <Box
//                                 // background={{image: "url("+InteractiveCanvas+")", position: "bottom", size: "contain", color: "#BCE2F8"}}
//                                 fill="horizontal"
//                                 height={"auto"}
//                                 style={{ position: "absolute", bottom: "0", right: "0", aspectRatio: "8 / 5" }}
//                             >
//                                 <CatDescriptionButton
//                                     color="cpaw-teal"
//                                     cat="Community Plans"
//                                     icon={ComPlanThumb}
//                                     bottom="15"
//                                     right="30"
//                                     description={
//                                         <Paragraph>
//                                             Community plans express long-term vision, policy direction, and strategies
//                                             for growth and development.
//                                         </Paragraph>
//                                     }
//                                 />
//                                 <CatDescriptionButton
//                                     color="cpaw-orange"
//                                     cat="Land Development"
//                                     icon={LandDevThumb}
//                                     bottom="30"
//                                     right="12"
//                                     description={
//                                         <Paragraph>
//                                             Landscaping, housing density, and open space can be planned and regulated to
//                                             reduce wildfire risk to homes and properties.
//                                         </Paragraph>
//                                     }
//                                 />
//                                 <CatDescriptionButton
//                                     color="cpaw-burntorange"
//                                     cat="Building and Fire Codes"
//                                     icon={BuildCodeThumb}
//                                     bottom="20"
//                                     right="43"
//                                     description={
//                                         <Paragraph>
//                                             Regulations promote fire prevention by codifying safety standards for
//                                             building construction, design, and function.
//                                         </Paragraph>
//                                     }
//                                 />
//                                 <CatDescriptionButton
//                                     color="cpaw-sage"
//                                     cat="Fuels Treatment"
//                                     icon={FuelsReductionThumb}
//                                     bottom="38"
//                                     right="34"
//                                     description={
//                                         <Paragraph>
//                                             Removing or thinning vegetation can mitigate wildfire hazards by reducing
//                                             the continuity and availability of fuels.
//                                         </Paragraph>
//                                     }
//                                 />
//                                 <CatDescriptionButton
//                                     color="cpaw-red"
//                                     cat="Funding and Engagement"
//                                     icon={FundEngageThumb}
//                                     bottom="1"
//                                     right="12"
//                                     description={
//                                         <Paragraph>
//                                             Assessing and mapping wildfire risk helps engage the community and secure
//                                             funding for wildfire mitigation projects.
//                                         </Paragraph>
//                                     }
//                                 />
//                             </Box>
//                         </>
//                     ) : (
//                         <Box
//                             overflow={"scroll"}
//                             fill
//                             flex="shrink"
//                             background={"linear-gradient(180deg, rgba(255,255,255,.3) 40%, rgba(255,255,255,0) 60%)"}
//                             pad={{ horizontal: "large" }}
//                         >
//                             <CatDescription
//                                 header={
//                                     <ToolListIcon
//                                         input={ToolBoxInfo}
//                                         color={"cpaw-teal"}
//                                         icon={ComPlanThumb}
//                                         cat={"Community Plans"}
//                                     />
//                                 }
//                             >
//                                 <Paragraph>
//                                     Community plans express long-term vision, policy direction, and strategies for
//                                     growth and development.
//                                 </Paragraph>
//                                 <ToolList input={ToolBoxInfo} cat={"Community Plans"} color={"cpaw-teal"} />
//                             </CatDescription>

//                             <CatDescription
//                                 header={
//                                     <ToolListIcon
//                                         input={ToolBoxInfo}
//                                         color={"cpaw-orange"}
//                                         icon={LandDevThumb}
//                                         cat={"Land Development"}
//                                     />
//                                 }
//                             >
//                                 <Paragraph>
//                                     Landscaping, housing density, and open space can be planned and regulated to reduce
//                                     wildfire risk to homes and properties.
//                                 </Paragraph>
//                                 <ToolList input={ToolBoxInfo} cat={"Land Development"} color={"cpaw-orange"} />
//                             </CatDescription>

//                             <CatDescription
//                                 header={
//                                     <ToolListIcon
//                                         input={ToolBoxInfo}
//                                         color={"cpaw-burntorange"}
//                                         icon={BuildCodeThumb}
//                                         cat={"Building and Fire Codes"}
//                                     />
//                                 }
//                             >
//                                 <Paragraph>
//                                     Regulations promote fire prevention by codifying safety standards for building
//                                     construction, design, and function.
//                                 </Paragraph>
//                                 <ToolList
//                                     input={ToolBoxInfo}
//                                     cat={"Building and Fire Codes"}
//                                     color={"cpaw-burntorange"}
//                                 />
//                             </CatDescription>

//                             <CatDescription
//                                 header={
//                                     <ToolListIcon
//                                         input={ToolBoxInfo}
//                                         color={"cpaw-sage"}
//                                         icon={FuelsReductionThumb}
//                                         cat={"Fuels Treatment"}
//                                     />
//                                 }
//                             >
//                                 <Paragraph>
//                                     Removing or thinning vegetation can mitigate wildfire hazards by reducing the
//                                     continuity and availability of fuels.
//                                 </Paragraph>
//                                 <ToolList input={ToolBoxInfo} cat={"Fuels Treatment"} color={"cpaw-sage"} />
//                             </CatDescription>

//                             <CatDescription
//                                 header={
//                                     <ToolListIcon
//                                         input={ToolBoxInfo}
//                                         color={"cpaw-red"}
//                                         icon={FundEngageThumb}
//                                         cat={"Funding and Engagement"}
//                                     />
//                                 }
//                             >
//                                 <Paragraph>
//                                     Assessing and mapping wildfire risk helps engage the community and secure funding
//                                     for wildfire mitigation projects.
//                                 </Paragraph>
//                                 <ToolList input={ToolBoxInfo} cat={"Funding and Engagement"} color={"cpaw-red"} />
//                             </CatDescription>
//                         </Box>
//                     )}
//                 </Box>
//             </Box>
//         );
//     };

//     function ToolButton({ title, color, slug }) {
//         const obj = ToolBoxInfo.findIndex((item) => item.title === title);
//         let match = useRouteMatch({
//             path: "/" + slug,
//             exact: true,
//         });

//         return (
//             <Box
//                 hoverIndicator={{ background: { color: color, opacity: "weak" } }}
//                 fill="horizontal"
//                 className={"toolbox-nav"}
//                 background={match ? { color: color, opacity: "medium" } : ""}
//                 color={color}
//                 pad={
//                     screenSize != "mobile"
//                         ? { horizontal: "small", vertical: "xxsmall" }
//                         : { horizontal: "medium", vertical: "small" }
//                 }
//                 height={{ min: "fit-content" }}
//                 onClick={() => {
//                     setSelectedPostMeta({ slug: slug, source: ToolBoxInfo[obj], color: color });
//                     setSelectedCat(null);
//                 }}
//             >
//                 <Link style={{ textDecoration: "none" }} to={slug}>
//                     <Text size="small" color={"black"}>
//                         {title}
//                     </Text>
//                 </Link>
//             </Box>
//         );
//     }

//     const ToolList = ({ input, cat, color }) => {
//         const catClass = cat.replace(/\s+/g, "-").toLowerCase();
//         const ToolCats = input
//             .filter((item) => item.category === cat)
//             .map((item, i) => (
//                 <ToolButton key={"ToolCat-" + i} title={item.title} content={input} color={color} slug={item.slug} />
//             ));

//         return (
//             <Box
//                 direction="column"
//                 gap="xxsmall"
//                 width={{ min: "fit-content" }}
//                 margin={{ bottom: "small" }}
//                 className={catClass + " tool-cat"}
//                 background={selectedCat === cat ? { color: color, opacity: "weak" } : { color: color, opacity: "0" }}
//                 style={{ transition: "all ease-in-out .5s" }}
//                 height={{ min: "fit-content" }}
//             >
//                 <Box
//                     border={{ side: "left", size: "medium", color: color }}
//                     pad={{ horizontal: screenSize != "mobile" ? "xsmall" : "small" }}
//                     background={{ color: color, opacity: "weak" }}
//                 >
//                     <Text size="small" weight={"bolder"} color={color}>
//                         {cat.replace(" and ", " & ")}
//                     </Text>
//                 </Box>
//                 {ToolCats}
//             </Box>
//         );
//     };

//     const ToolListIcon = ({ input, cat, color, icon }) => {
//         const catClass = cat.replace(/\s+/g, "-").toLowerCase();

//         return (
//             <Box
//                 height={{ min: "xsmall", size: "small" }}
//                 className={"shadow " + catClass + "-icon"}
//                 style={{ zIndex: "3" }}
//                 direction="row"
//                 align="center"
//                 fill={"horizontal"}
//             >
//                 <Box
//                     round="100%"
//                     height={"auto"}
//                     width={"xsmall"}
//                     overflow="hidden"
//                     border={{ color: color, size: "medium" }}
//                     className={"shadow-inset"}
//                     background={{ image: "url(" + icon + ")", size: "cover" }}
//                     style={{ aspectRatio: "1 / 1", zIndex: "3" }}
//                 ></Box>
//                 <Box
//                     round={"xxsmall"}
//                     background={color}
//                     pad={{ left: "1.25em", right: "xsmall", vertical: "xxsmall" }}
//                     style={{ zIndex: "0", marginLeft: "-1em" }}
//                     flex="grow"
//                 >
//                     <Heading level="3" size="large" color="white" margin={"none"}>
//                         {cat.replace(" and ", " & ")}
//                     </Heading>
//                 </Box>
//             </Box>
//         );
//     };

//     const ToolBoxNav = () => {
//         let match = useRouteMatch({
//             path: "/",
//             exact: true,
//         });
//         const { screenSize } = useViewport();
//         return screenSize !== "mobile" ? (
//             <Box
//                 fill="vertical"
//                 pad={{ top: "medium", left: "medium" }}
//                 direction="column"
//                 gap="xxsmall"
//                 width={{ min: "fit-content", max: "medium", width: "large" }}
//                 background={{ color: "light-1", opacity: "strong" }}
//                 height={{ min: "fit-content" }}
//             >
//                 <Box direction="row" height={{ min: "fit-content" }}>
//                     <Box width={"2.25rem"} height={"4rem"} alignSelf={"end"}>
//                         <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 486.33 720">
//                             <path
//                                 fill="#C36535"
//                                 d="M465.92,353.61c-34.32-65.79-36.59-81.92-42.34-92.97-3.45-6.62-6.37-6.97-9.55-5.75-4.49,1.73-3.45,13.46-6.21,20.71,0,0-13.12,41.42-46.94,49.36,22.44-35.21,25.17-69.31,15.3-107.46-20.01-77.28-112.29-156.14-133-170.41-19.71-13.58-53.39-32.68-74.56-40.04-8.66-3.01-32.72-8.97-35.44-6.44-2.71,2.52,.87,7.57,4.43,14.77,3.57,7.2,25.03,45.16,36.53,95.51,11.5,50.34-19.45,85.53-72.37,139.86-12.06,12.38-23.46,24.08-33.79,36.05C-2.71,360.06-19.92,472.5,24.14,573.32c39.55,90.48,119.43,146.69,208.49,146.68h.02c2,0,4.03-.03,5.65-.08,78.58,1.23,154.35-41.25,202.18-113.81,50.47-76.57,59.76-186.72,25.43-252.51Z"
//                             />
//                         </svg>
//                     </Box>
//                     <Heading level={"1"} margin="none">
//                         <Text size={"4rem"} weight={"bolder"}>
//                             Fire
//                         </Text>
//                         <Text size="4rem" weight={"lighter"}>
//                             topia
//                         </Text>
//                     </Heading>
//                 </Box>

//                 <Box
//                     fill="horizontal"
//                     margin={{ bottom: "xsmall" }}
//                     height={{ min: "fit-content" }}
//                     direction="row"
//                     justify="start"
//                     round={{ corner: "left", size: "large" }}
//                     background={!match ? { color: "light-4", opacity: "1" } : { color: "none" }}
//                     overflow="hidden"
//                 >
//                     <Box
//                         flex="grow"
//                         // onClick={() => {
//                         //     setSelectedPostMeta(null);
//                         // }}
//                         className={"toolbox-nav" + (match === null ? " active" : "")}
//                         focusIndicator="false"
//                     >
//                         <Link style={{ textDecoration: "none", color: "#222" }} to="/">
//                             <Box
//                                 direction="row"
//                                 gap="xsmall"
//                                 pad={{ horizontal: "small", vertical: "xxsmall" }}
//                                 hoverIndicator={{ background: { color: "accent-2" } }}
//                                 focusIndicator="false"
//                             >
//                                 <FontAwesomeIcon color="dark-1" icon={faArrowAltToLeft} size={"1x"} />
//                                 <Text size="small">Home screen</Text>
//                             </Box>
//                         </Link>
//                     </Box>
//                     <Box
//                         fill="horizontal"
//                         direction="row"
//                         gap="xsmall"
//                         pad={{ horizontal: "small", vertical: "xxsmall" }}
//                         border={{ side: "left", size: "xsmall", color: "#bababa" }}
//                         hoverIndicator={{ background: { color: "brand" } }}
//                         onClick={() => {
//                             window.location = "https://hecpawdev.wpengine.com";
//                         }}
//                     >
//                         <FontAwesomeIcon icon={faHome} size={"1x"} />
//                         <Text size="small">Back to CPAW</Text>
//                     </Box>
//                 </Box>

//                 <Box overflow={{ vertical: "auto" }}>
//                     <ToolList input={ToolBoxInfo} cat="Community Plans" color="cpaw-teal" />

//                     <ToolList input={ToolBoxInfo} cat="Land Development" color="cpaw-orange" />

//                     <ToolList input={ToolBoxInfo} cat="Building and Fire Codes" color="cpaw-burntorange" />

//                     <ToolList input={ToolBoxInfo} cat="Fuels Treatment" color="cpaw-sage" />

//                     <ToolList input={ToolBoxInfo} cat="Funding and Engagement" color="cpaw-red" />
//                 </Box>
//             </Box>
//         ) : (
//             <Header className="mobile-header" elevation="small" background={"light-1"} style={{ zIndex: "2" }}>
//                 <Box pad={{ horizontal: "small", vertical: "xsmall" }} direction="row">
//                     <Box width={"2rem"} height={"2.5rem"} alignSelf={"end"} pad={{ bottom: "xsmall" }}>
//                         <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 486.33 720">
//                             <path
//                                 fill="#C36535"
//                                 d="M465.92,353.61c-34.32-65.79-36.59-81.92-42.34-92.97-3.45-6.62-6.37-6.97-9.55-5.75-4.49,1.73-3.45,13.46-6.21,20.71,0,0-13.12,41.42-46.94,49.36,22.44-35.21,25.17-69.31,15.3-107.46-20.01-77.28-112.29-156.14-133-170.41-19.71-13.58-53.39-32.68-74.56-40.04-8.66-3.01-32.72-8.97-35.44-6.44-2.71,2.52,.87,7.57,4.43,14.77,3.57,7.2,25.03,45.16,36.53,95.51,11.5,50.34-19.45,85.53-72.37,139.86-12.06,12.38-23.46,24.08-33.79,36.05C-2.71,360.06-19.92,472.5,24.14,573.32c39.55,90.48,119.43,146.69,208.49,146.68h.02c2,0,4.03-.03,5.65-.08,78.58,1.23,154.35-41.25,202.18-113.81,50.47-76.57,59.76-186.72,25.43-252.51Z"
//                             />
//                         </svg>
//                     </Box>
//                     <Heading level={"1"} margin="none">
//                         <Text size={"2.5rem"} weight={"bolder"}>
//                             Fire
//                         </Text>
//                         <Text size="2.5rem" weight={"lighter"}>
//                             topia
//                         </Text>
//                     </Heading>
//                 </Box>
//                 <DropButton
//                     open={open}
//                     onOpen={onOpen}
//                     onClose={onClose}
//                     dropContent={
//                         <Box onClick={onClose} overflow={{ vertical: "scroll" }}>
//                             <Box
//                                 fill="horizontal"
//                                 height={{ min: "fit-content" }}
//                                 direction="row"
//                                 justify="between"
//                                 background={!active ? { color: "light-4", opacity: "1" } : { color: "none" }}
//                             >
//                                 <Box
//                                     flex="grow"
//                                     // onClick={() => {
//                                     //     setSelectedPostMeta(null);
//                                     // }}
//                                     className={"toolbox-nav" + (match === null ? " active" : "")}
//                                     focusIndicator="false"
//                                     justify="center"
//                                 >
//                                     <Link style={{ textDecoration: "none", color: "#222" }} to="/">
//                                         <Box
//                                             direction="row"
//                                             gap="xsmall"
//                                             pad={{ horizontal: "small", vertical: "xxsmall" }}
//                                             hoverIndicator={{ background: { color: "accent-2" } }}
//                                             focusIndicator="false"
//                                         >
//                                             <FontAwesomeIcon color="dark-1" icon={faArrowAltToLeft} size={"1x"} />
//                                             <Text size="small">Home screen</Text>
//                                         </Box>
//                                     </Link>
//                                 </Box>
//                                 <Box
//                                     flex="grow"
//                                     direction="row"
//                                     gap="xsmall"
//                                     pad={{ horizontal: "medium", vertical: "small" }}
//                                     border={{ side: "left", size: "xsmall", color: "#bababa" }}
//                                     hoverIndicator={{ background: { color: "brand" } }}
//                                     onClick={() => {
//                                         window.location = "https://hecpawdev.wpengine.com";
//                                     }}
//                                 >
//                                     <FontAwesomeIcon icon={faHome} size={"1x"} />
//                                     <Text size="small">CPAW</Text>
//                                 </Box>
//                             </Box>

//                             <ToolList input={ToolBoxInfo} cat="Community Plans" color="cpaw-teal" />

//                             <ToolList input={ToolBoxInfo} cat="Land Development" color="cpaw-orange" />

//                             <ToolList input={ToolBoxInfo} cat="Building and Fire Codes" color="cpaw-burntorange" />

//                             <ToolList input={ToolBoxInfo} cat="Fuels Treatment" color="cpaw-sage" />

//                             <ToolList input={ToolBoxInfo} cat="Funding and Engagement" color="cpaw-red" />
//                         </Box>
//                     }
//                 >
//                     <Box pad={{ vertical: "xsmall", horizontal: "medium" }}>
//                         <FontAwesomeIcon icon={faBars} size="2x" />
//                     </Box>
//                 </DropButton>
//             </Header>
//         );
//     };

//     return (
//         <BrowserRouter>
//             <ViewportProvider>
//                 <Grommet className="app" theme={cpawTheme}>
//                     {isInteractiveVisible && (
//                         <Layer
//                             id="scrollmodal"
//                             onEsc={() => set_isInteractiveVisible(false)}
//                             onClickOutside={() => set_isInteractiveVisible(false)}
//                             modal
//                         >
//                             <ModalContent set_isInteractiveVisible={set_isInteractiveVisible} />
//                         </Layer>
//                     )}

//                     <Box
//                         full
//                         height={{ min: "100vh" }}
//                         width={{ min: "100vw" }}
//                         style={{ zIndex: "2" }}
//                         background={{ image: "url(" + blurredBG + ")", size: "cover" }}
//                     >
//                         <Grid rows={["1fr", "auto"]} fill height={{ max: "100vh", min: "100vh" }}>
//                             <Box gap="none" fill direction={screenSize != "mobile" ? "row" : "column"}>
//                                 <ToolBoxNav />
//                                 <Box
//                                     fill
//                                     background={{ color: "light-1", opacity: "strong" }}
//                                     border={[
//                                         {
//                                             side: "left",
//                                             size: selectedPostMeta ? "small" : "0px",
//                                             color: selectedPostMeta ? selectedPostMeta.color : "white",
//                                         },
//                                     ]}
//                                     elevation="small"
//                                     style={{ zIndex: "3" }}
//                                 >
//                                     {/* {selectedPostMeta ? <ToolBoxContent /> : <ToolBoxSplash />} */}
//                                     <Switch>
//                                         <Route exact path="/" component={ToolBoxSplash} />
//                                         <Route path="/:slug" component={ToolBoxContent} />
//                                         <Route path="*" component={ToolBoxSplash} />
//                                     </Switch>
//                                 </Box>
//                             </Box>
//                             <Box
//                                 pad={"xsmall"}
//                                 background={{ color: "light-1", opacity: "strong" }}
//                                 justify="end"
//                                 direction="row"
//                             >
//                                 <Box>
//                                     <Text textAlign="end">&copy;{new Date().getFullYear()} Headwaters Economics</Text>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Box>
//                 </Grommet>
//             </ViewportProvider>
//         </BrowserRouter>
//     );
// }

// //Split out so Storybook can use a different type of router
// function Routed({ storybookState }) {
//     return (
//         <ViewportProvider>
//             <App />
//         </ViewportProvider>
//     );
// }

// export { Routed };
// export default App;
